import styled, { keyframes } from "styled-components";

export const CarrinhoPagamentoContentStyle = styled.div`
  /* width: 80%; */
  width: 90%;
  max-width: 800px;
  border-radius: 10px;
  padding: 30px 0px 30px 0px;

  div {
    background-color: #fff;
  }

  .payment {
    padding: 10px;
    margin-top: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  .payment-option {
    padding: 12px 0px 12px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment.selected {
    border: 2px solid purple;
    box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.2);
  }

  .payment-left {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .payment-title {
    margin: 0;
    font-weight: bold;
  }

  .payment-subtitle {
    margin: 0;
    font-size: 14px;
    color: #555;
  }

  .payment-right {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .payment-price {
    color: green;
    font-weight: bold;
  }

  .payment-checkbox {
    width: 18px;
    height: 18px;
    accent-color: purple;
  }

  .pix-button {
    background-color: #333;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 10px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 10px;
    width: 100%;
    transition: background-color 0.2s ease, transform 0.1s ease;
  }

  .disabled-link {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
  }

  .pix-button:hover {
    background-color: #555;
  }

  .pix-button:disabled {
    background-color: #999;
    color: #eee;
    cursor: not-allowed;
    opacity: 0.7;
  }

  .pix-button:active:not(:disabled) {
    transform: scale(0.98);
  }

  .voltar-button {
    margin-top: 20px;
    background: purple;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 6px;
    padding: 10px;
    width: 100%;
    cursor: pointer;
  }

  .header-right {
    color: #16a34a; /* verde */
    font-weight: bold;
    font-size: 1.2rem;
  }

  .payment-checkbox {
    width: 18px;
    height: 18px;
  }

  /* Expanded section */
  .credit-card-section {
    padding: 16px;
    border-top: 1px solid #eee;
  }

  .desc-payment {
    font-size: 17px;
    color: #666;
    margin-bottom: 12px;
  }

  .selected-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 10px 14px;
    margin-bottom: 14px;
  }

  .selected-card .card-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .selected-card .card-brand {
    width: 36px;
    height: auto;
  }

  .delete-btn {
    background: none;
    border: none;
    color: #1976d2;
    cursor: pointer;
    font-size: 14px;
  }

  .form-row {
    display: flex;
    gap: 10px;
    margin-bottom: 14px;
  }

  .input {
    flex: 1;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
  }

  .input.half {
    flex: 0 0 50%;
  }

  .use-other-card {
    display: inline-block;
    margin-bottom: 16px;
    font-size: 14px;
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
  }

  .pix-button {
    display: block;
    width: 100%;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background: #000;
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    .payment-right {
      gap: 10px;
    }
    .header-right {
      font-size: 18px;
    }
    .payment-option {
      padding: 14px 16px;
    }
    .payment-left {
      font-size: 16px;
      gap: 10px;
    }
    .carteira-saldo {
      font-size: 2rem;
    }
  }
  /* #endregion DESKTOP */
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
export const PagamentoProcessandoContentStyle = styled.div`
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  max-width: 800px;
  min-height: 450px;

  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    max-width: 90%;
    margin: 0 auto;
    text-align: center;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .spinner {
    border: 6px solid #f3f3f3;
    border-top: 6px solid #812990;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: ${spin} 1s linear infinite;
    margin-bottom: 20px;
  }

  .icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white !important;
  }

  .icon.pending {
    background-color: #f1c40f;
  }

  .icon.error {
    background-color: #e74c3c;
  }

  .icon.success {
    background-color: #2ecc71;
  }

  .pending {
    color: #f59e0b;
  }

  .error {
    color: #ef4444;
  }

  .success {
    color: #22c55e;
  }

  p {
    margin-top: 10px;
    font-weight: 500;
    font-size: 20px;
    color: #555;
  }

  h2 {
    margin-top: 20px;
    font-weight: 600;
    font-size: 24px;
  }

  button {
    margin-top: 20px;
    padding: 10px 20px;
    border-radius: 8px;
    border: none;
    background-color: #812990;
    color: #fff;
    cursor: pointer;
    font-weight: 500;
    width: 100%;
  }
`;

export const PagamentoPixStyle = styled.div`
  .container {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 24px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .header-left {
    font-weight: 600;
    color: #444;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .qrcode-box {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
  }

  .qrcode-img {
    width: 190px;
    height: 190px;
  }

  .info {
    text-align: center;
    color: #555;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .small-info {
    font-size: 12px;
    text-align: center;
    color: #777;
    margin-bottom: 16px;
  }

  .copy-btn {
    width: 100%;
    background: #222;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      background: #444;
    }
  }

  .back-btn {
    width: 100%;
    margin-top: 12px;
    border: 0px solid #6d28d9;
    color: #ffffffff;
    background-color: #822a91;
    border-radius: 8px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      background: #6f247cff;
    }
  }

  .copy-btn.copied {
    background-color: #faecffff;
    color: #822a91;
    border: 1px solid #ccc;
    border: 1px solid #822a91;
  }
`;

export const PagamentoCartaoStyle = styled.div`
  .pagamento-cartao {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .titulo {
    font-size: 1.2em;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .error-message {
    color: #e63946;
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
  }

  .card-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #444;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    background-color: #fff;
  }

  .card-item.selected {
    border: 2px solid #822a91;
  }

  .card-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .card-name {
    font-weight: 500;
  }

  .valor {
    color: #0f0;
    font-weight: 600;
    margin-right: 8px;
  }

  .delete-btn {
    cursor: pointer;
  }

  .add-card {
    border: 2px solid #a050f0;
    border-radius: 8px;
    padding: 12px;
    text-align: center;
    color: #a050f0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    gap: 8px;
    align-items: center;
  }

  .back-btn {
    width: 100%;
    border: 0px solid #6d28d9;
    color: #ffffffff;
    background-color: #822a91;
    border-radius: 8px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      background: #6f247cff;
    }
  }

  .back-btn:disabled {
    background-color: #b88cc1;
    color: #eee;
    cursor: not-allowed;
    opacity: 0.7;
  }

  .save-btn {
    width: 100%;
    margin-bottom: 5px;
    border: 2px solid #822a91;
    color: #822a91;
    background-color: #f3eeeeff;
    border-radius: 8px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      color: #ded3e0ff;
      background: #6f247cff;
    }
  }

  .credit-card-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 15px;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  .credit-card-form .input {
    padding: 10px;
    border: 1px solid #444;
    color: #000;
    border-radius: 4px;
  }

  .credit-card-form .row {
    display: flex;
    gap: 10px;
  }

  .credit-card-form .half {
    flex: 1;
  }

  .payment-checkbox {
    width: 18px;
    height: 18px;
    accent-color: purple;
  }
  .save-card {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #252525ff;
    gap: 8px;
    justify-content: flex-end;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 24px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #c4c7c9ff;
    transition: 0.4s;
    border-radius: 24px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  .switch input:checked + .slider {
    background-color: #812990;
  }

  .switch input:checked + .slider:before {
    transform: translateX(22px);
  }

  .use-other-card {
    display: inline-block;
    margin-bottom: 0px;
    font-size: 14px;
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
  }

  .pix-button {
    background-color: #333;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 10px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 10px;
    width: 100%;
    transition: background-color 0.2s ease, transform 0.1s ease;
  }

  .pix-button:hover {
    background-color: #555;
  }

  .pix-button:disabled {
    background-color: #999;
    color: #eee;
    cursor: not-allowed;
    opacity: 0.7;
  }

  .pix-button:active:not(:disabled) {
    transform: scale(0.98);
  }
  .disabled-link {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
